import DevSection from './DevSection'
import { isDevToolAvailable } from '../../../devToolCapabilities'
import { confirmReset } from './confirmations'
import type { DataMode } from '../../../dataMode'

export interface LocalSectionProps {
  mode: DataMode | null
  hasGames: boolean
  onDevClearRevealSeen: () => void
  onResetAll: (confirm?: string) => void
}

/**
 * The two tools that survive in every mode.
 *
 * They sit together because they share a property nothing else in the rail has: neither one
 * fabricates football. "Clear seen" is per-user, cosmetic and undone by a reload; "reset all data"
 * is destructive but is also the only way out of a bad state, which is why it stays reachable in
 * live and takes friction instead.
 */
export default function LocalSection({
  mode,
  hasGames,
  onDevClearRevealSeen,
  onResetAll,
}: LocalSectionProps) {
  const showClearSeen = isDevToolAvailable('clearRevealSeen', mode) && hasGames
  const showReset = isDevToolAvailable('resetAll', mode)
  if (!showClearSeen && !showReset) return null

  return (
    <DevSection title="Local">
      {showClearSeen && (
        <button
          className="gameweek-grid__dev-btn"
          onClick={onDevClearRevealSeen}
          title="Dev: clear reveal-seen for this gameweek"
        >
          <span className="gameweek-grid__dev-btn-label">Clear seen</span>🔁
        </button>
      )}
      {showReset && (
        <button
          className="gameweek-grid__dev-reset-btn"
          onClick={() => {
            const confirmed = confirmReset(mode)
            if (confirmed.ok) onResetAll(confirmed.confirm)
          }}
        >
          🗑 Dev: reset all data
        </button>
      )}
    </DevSection>
  )
}
